import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function rutClean(value: string) {
  if (typeof value === 'string') {
    return value
      .replace(/[^0-9kK]+/g, '')
      .replace(/^0+/, '')
      .toUpperCase();
  }
  return '';
}

export function rutFormat(value: string) {
  const rut = rutClean(value);
  if (rut.length <= 1) {
    return rut;
  }
  let result = `${rut.slice(-4, -1)}-${rut.substring(rut.length - 1)}`;
  for (let i = 4; i < rut.length; i += 3) {
    result = `${rut.slice(-3 - i, -i)}.${result}`;
  }
  return result;
}

export function RutValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const rut = rutClean(control.value);

    if (rut.length === 0) return null;

    if (rut.length < 8) return { rutInvalido: true };

    let rutDigits = parseInt(rut.slice(0, -1), 10);
    let m = 0;
    let s = 1;
    while (rutDigits > 0) {
      s = (s + rutDigits % 10 * (9 - m++ % 6)) % 11;
      rutDigits = Math.floor(rutDigits / 10);
    }
    const checkDigit = (s > 0) ? String((s - 1)) : 'K';

    if (checkDigit === rut.slice(-1)) {
      return null
    } else {
      return { rutInvalido: true };
    }
  };
}
